import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';

import { Router, RouterLink } from '@angular/router';
import {
  BehaviorSubject,
  Observable,
  Subject,
  map,
  take,
  takeUntil,
} from 'rxjs';
import {
  Collection,
  Customer,
  GetCollectionsQuery,
  GetCollectionsQueryVariables,
} from '../../../graphql/generated/generated-types';
import { ActiveService } from '../../../core/providers/active/active.service';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { LoginDialogComponent } from '../../dialogs/auth/login-dialog/login-dialog.component';
import { DataService } from '../../../core/providers/data/data.service';
import { GET_LANDING_COLLECTIONS } from '../../../routes/landing/components/product-categories/landing-collections.graphql';
import { WatchQueryFetchPolicy } from '@apollo/client/core';
import { SlugTypes } from '../../../routes/landing/components/product-categories/product-category-search-block/product-category-search-block.component';
import { HttpErrorResponse } from '@angular/common/http';
import { Platform } from '@angular/cdk/platform';
import { VERSION } from '../../../../environments/version';
import { BUILD } from '../../../../environments/build';
import { environment } from '../../../../environments/environment';
import { VehicleTypeService } from '../../services/vehicle-type.service';
import { SelectedModificationService } from '../../services/selected-modification.service';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [CommonModule, RouterLink, LoginDialogComponent],

  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class FooterComponent implements OnInit {
  public version: string = VERSION;
  public build: string = BUILD;
  public isProduction: boolean = environment.production;

  activeCustomer$: Observable<Customer>;
  private unsubscribe$ = new Subject<void>();

  public SlugTypes = SlugTypes;
  public collections!: Collection[];

  public collectionsloading$ = new BehaviorSubject<boolean>(true);

  constructor(
    private activeService: ActiveService,
    private dialogService: DialogService,
    private dataService: DataService,
    private platform: Platform,
    public vehicleTypeService: VehicleTypeService,
    public selectedModificationService: SelectedModificationService,
    private router: Router
  ) {}

  ngOnInit(): void {
    if (this.platform.isBrowser) {
      this.getActiveCustomer();
    }
    this.subscribeToCollections();
    this.getCollections();
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  private getActiveCustomer() {
    this.activeCustomer$ = this.activeService.activeCustomer$.pipe(
      takeUntil(this.unsubscribe$)
    );
  }

  public getCollections() {
    this.collectionsloading$.next(true);
    this.subscribeToCollections()
      .pipe(take(1))
      .subscribe({
        next: (response: Collection[]) => {
          this.collections = response;
          this.collectionsloading$.next(false);
        },
        error: (error: HttpErrorResponse) => {
          this.collectionsloading$.next(false);
        },
      });
  }

  private subscribeToCollections() {
    return this.dataService
      .query<GetCollectionsQuery, GetCollectionsQueryVariables>(
        GET_LANDING_COLLECTIONS,
        {
          options: {
            take: 6,
            topLevelOnly: true,
          },
        },
        'cache-and-network' as WatchQueryFetchPolicy
      )
      .pipe(
        takeUntil(this.unsubscribe$),
        map(
          (response: GetCollectionsQuery) =>
            response.collections.items as Collection[]
        ),
        map((collections: Collection[]) => {
          if (environment.websiteSettings.hideEmptyCatalogCategories) {
            return collections
              .filter((item) => item.productsCount !== 0)
              .map((item) => ({
                ...item,
                children:
                  item.children?.filter((child) => child.productsCount !== 0) ??
                  [],
              }));
          }

          return collections;
        })
      );
  }
  public openLoginDialog() {
    const dialogRef: DynamicDialogRef = this.dialogService.open(
      LoginDialogComponent,
      {
        styleClass: 'auth-custom-dialog',
        modal: true,
        showHeader: false,
        closeOnEscape: true,
        dismissableMask: true,
      }
    );

    dialogRef.onClose.subscribe((result) => {
      if (result) {
           /*
        this.router.navigate(['/'], { queryParamsHandling: 'merge', skipLocationChange: true }).then(() => {
          this.router.navigate(['/' + (this.vehicleTypeService.currentVehicleType)], {
            queryParamsHandling: 'merge'
          });
        })
           */

      }
    });
  }
}
